export default () => ({
  fileInput: {
    display: 'none'
  }
})
